export default "__VITE_ASSET__DbDkTD4O__"